// @ts-check

import { getProduct } from '@/api/products'
import {
  AUTHENTICATION_REQUIRED,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'
import * as _ from 'lodash-es'

/** @type {import('vue-router').RouteRecordRaw[]} */
export const productRoutes = [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/Products.vue'),
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: true,
      icon: '$cube-outline',
      [ROUTE_NAME]: 'products'
    }
  },
  {
    path: '/products/new',
    name: 'new_product',
    component: () => import('@/views/EditProduct.vue'),
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: false,
      [ROUTE_NAME]: 'new_product'
    }
  },
  {
    path: '/products/:id(\\d+)',
    name: 'edit_product',
    component: () => import('@/views/EditProduct.vue'),
    beforeEnter: async (to) => {
      const product = await getProduct(+to.params.id)

      if (!product.product.can_edit) {
        return false
      }

      _.set(to, 'meta.product', product)

      return true
    },
    props: (route) => {
      return { product: route.meta.product }
    },
    meta: {
      [AUTHENTICATION_REQUIRED]: true,
      [IS_IN_MAIN_NAV]: false,
      [ROUTE_NAME]: 'edit_product'
    }
  }
]

export default productRoutes
